import { createFileRoute } from '@tanstack/react-router'
import { SITE_IMAGES } from '@/lib/site-images'

export const Route = createFileRoute('/about')({
  head: () => ({
    meta: [
      { title: 'About — Halo Compliance' },
      {
        name: 'description',
        content:
          'Meet the Halo Compliance team — compliance professionals passionate about easing the compliance workload for mortgage teams.',
      },
      { property: 'og:title', content: 'About — Halo Compliance' },
      { property: 'og:url', content: 'https://www.halocompliance.com/about' },
    ],
    links: [{ rel: 'canonical', href: 'https://www.halocompliance.com/about' }],
  }),
  component: AboutPage,
})

const TEAM = [
  { name: 'Tyler Moore', image: SITE_IMAGES.team.tyler, alt: 'Tyler Moore' },
  { name: 'Malcolm Bertenshaw', image: SITE_IMAGES.team.malcolm, alt: 'Malcolm Bertenshaw' },
  { name: 'Sarah Simms', image: SITE_IMAGES.team.sarah, alt: 'Sarah Simms' },
  { name: 'Chris Bunker', image: SITE_IMAGES.team.chris, alt: 'Chris Bunker' },
  { name: 'Javier Hardman', image: SITE_IMAGES.team.javier, alt: 'Javier Hardman' },
] as const

function AboutPage() {
  return (
    <div className="marketing-inner py-5">
      <div className="container py-4">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-9 text-center">
            <h1 className="display-5 font-serif mb-4">Meet the team</h1>
            <p className="lead text-body-secondary mb-0">
              We're compliance professionals passionate about easing the compliance workload.
            </p>
          </div>
        </div>
        <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5 justify-content-center">
          {TEAM.map((member) => (
            <div key={member.name} className="col">
              <figure className="text-center mb-0">
                <img
                  src={member.image}
                  alt={member.alt}
                  className="rounded-circle img-fluid marketing-headshot shadow-sm mb-3"
                  width={180}
                  height={180}
                />
                <figcaption className="small fw-semibold">{member.name}</figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
